// This file was automatically generated from no_memo_update.html
// Any changes to this file will be overwritten when the script is run again

const memoUpdateContent = `<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Afterimage: Market Traction Update - Q2 2025</title>
    <style>
        body {
            font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
            line-height: 1.6;
            color: #333;
            margin: 0;
            padding: 0;
            background-color: #ffffff;
        }
        .page-container {
            display: grid;
            grid-template-columns: 1fr minmax(800px, 1000px) 1fr;
            max-width: 100%;
            min-height: 100vh;
        }
        .left-column {
            position: relative;
        }
        .toc-wrapper {
            position: sticky;
            top: 2rem;
            padding: 0 1rem;
            display: flex;
            justify-content: flex-end;
            height: fit-content;
            margin-top: 2rem; /* Added margin */
        }
        .main-column {
            padding: 2rem 3rem;
            background-color: #ffffff;
        }
        .right-column { } /* Empty */

        h1, h2, h3 {
            font-weight: 600;
            color: #1a1a1a;
            margin-top: 1.5em;
            margin-bottom: 0.75em;
        }
        h1 { /* Title */
            font-size: 2.8rem; /* Adjusted size */
            font-weight: 700;
            color: #2563eb;
            margin-bottom: 0.25rem;
            text-align: center;
            font-family: 'Montserrat', 'Inter', sans-serif;
            letter-spacing: -0.03em;
        }
         h2 { /* Section Titles */
            font-size: 1.6rem; /* Adjusted */
            border-bottom: 1px solid #eaeaea;
            padding-bottom: 0.5rem;
            margin-top: 2.5rem; /* Increased spacing */
         }
        h3 { /* Sub-section Titles */
            font-size: 1.25rem;
            margin-top: 1.5rem;
            margin-bottom: 0.5rem;
            color: #2563eb; /* Use accent color */
        }
        p { margin-bottom: 1.2em; }
        .subtitle {
            font-size: 1.5rem;
            color: #4b5563;
            max-width: 800px;
            margin: 0 auto 2rem auto;
            line-height: 1.4;
            text-align: center;
        }
        .highlight-box {
            background-color: #f0f7ff;
            padding: 1.5rem; /* Increased padding */
            border-left: 4px solid #2563eb;
            border-radius: 0 4px 4px 0;
            margin: 2rem 0; /* Increased margin */
            font-size: 1.1rem; /* Slightly larger font */
            line-height: 1.7;
        }
        .statistics {
            display: flex;
            flex-wrap: wrap;
            gap: 1.5rem;
            margin: 2rem 0;
            justify-content: space-around; /* Better alignment */
        }
        .stat-box {
            flex: 1;
            min-width: 220px; /* Slightly wider */
            background-color: #f9fafb;
            border: 1px solid #e5e7eb;
            border-radius: 6px;
            padding: 1.5rem; /* Increased padding */
            box-shadow: 0 1px 3px rgba(0,0,0,0.05);
            text-align: center; /* Center content */
        }
        .stat-number {
            font-size: 2.2rem; /* Larger number */
            font-weight: 700;
            color: #2563eb;
            margin-bottom: 0.5rem;
        }
        .stat-label {
            font-size: 0.9rem;
            color: #4b5563;
        }
        .chart-container {
            margin: 2.5rem auto; /* Increased margin */
            padding: 1rem;
            background-color: #f9fafb; /* Light background */
            border: 1px solid #e5e7eb; /* Subtle border */
            border-radius: 8px;
            max-width: 90%; /* Constrain width */
            text-align: center;
        }
        .chart-image {
            max-width: 100%;
            height: auto;
            border-radius: 4px; /* Slight rounding */
            margin-bottom: 0.5rem; /* Space before caption */
        }
        .chart-caption {
            margin-top: 0.5rem;
            font-size: 0.9rem;
            color: #4b5563;
            font-style: italic;
        }
        .image-description {
            margin-top: 1rem;
            padding: 0 1rem;
            text-align: left;
            font-size: 1rem;
            color: #333;
        }
        footer {
            margin-top: 3rem;
            border-top: 1px solid #eaeaea;
            padding: 1.5rem 0; /* Adjusted padding */
            font-size: 0.9rem;
            color: #6b7280;
            grid-column: 1 / -1; /* Ensure footer spans */
            background-color: #ffffff;
            text-align: center;
        }
        .footer-container {
            max-width: 1000px;
            margin: 0 auto;
            padding: 0 3rem;
        }

        /* TOC Styles */
        .toc-container {
            background-color: #f9fafb;
            border: 1px solid #e5e7eb;
            border-radius: 6px;
            padding: 1.2rem;
            box-shadow: 0 1px 3px rgba(0,0,0,0.05);
            width: 250px; /* Fixed width */
            height: fit-content;
        }
        .toc-header {
            color: #2563eb;
            font-size: 1.2rem;
            font-weight: 600;
            margin: 0;
            padding-bottom: 0.5rem;
            border-bottom: 1px solid #e5e7eb;
            cursor: pointer;
            display: flex;
            justify-content: space-between;
            align-items: center;
        }
         .toc-header:after {
            content: '▼'; /* Default to expanded */
            font-size: 0.8rem;
            color: #4b5563;
            transition: transform 0.3s ease;
        }
        .toc-header.collapsed:after {
            transform: rotate(-90deg); /* Rotate when collapsed */
        }
        .toc-content {
            height: fit-content; /* Default to expanded */
            opacity: 1;
            overflow: hidden;
            transition: all 0.3s ease;
        }
        .toc-content.collapsed {
            height: 0;
            opacity: 0;
        }
        .toc-list { list-style-type: none; padding: 0; margin: 0.75rem 0 0; }
        .toc-list li { margin-bottom: 0.75rem; }
        .toc-list li:last-child { margin-bottom: 0; }
        .toc-list li a {
            color: #1a1a1a;
            text-decoration: none;
            font-weight: 500;
            font-size: 0.9rem;
            transition: color 0.2s ease;
            display: flex; /* Use flex for alignment */
            align-items: center; /* Vertically align */
            padding: 0.25rem 0;
        }
        .toc-list li a:hover, .toc-list li a.active { color: #2563eb; }
        .toc-list li a:before { /* Bullet point */
            content: "";
            display: inline-block;
            width: 6px;
            height: 6px;
            min-width: 6px; /* Ensure size */
            margin-right: 8px;
            background-color: #d1d5db; /* Default gray */
            border-radius: 50%;
            transition: background-color 0.2s ease, transform 0.2s ease;
        }
        .toc-list li a:hover:before, .toc-list li a.active:before {
            background-color: #2563eb; /* Blue on hover/active */
            transform: scale(1.1); /* Slightly larger */
        }
        .toc-list li a.active { font-weight: 600; } /* Make active link bold */

        /* Mobile TOC */
        .mobile-toc { display: none; margin-bottom: 2rem; }
        .mobile-toc .toc-container { width: auto; max-width: 90%; margin: 0 auto; }

        /* Responsive Adjustments */
        @media (max-width: 1200px) {
            .page-container { grid-template-columns: 1fr minmax(0, 1000px) 1fr; } /* Allow center to shrink */
        }
        @media (max-width: 1024px) {
            .page-container { display: block; }
            .left-column, .right-column { display: none; }
            .main-column { width: 100%; max-width: 100%; padding: 1rem; box-sizing: border-box; }
            .mobile-toc { display: block; padding: 0 1rem; }
            footer { width: 100%; }
            .footer-container { width: 100%; padding: 0 1rem; box-sizing: border-box; }
            h1 { font-size: 2.2rem; }
            .subtitle { font-size: 1.2rem; }
            h2 { font-size: 1.4rem; }
            .statistics { flex-direction: column; }
            .stat-box { min-width: 100%; margin-bottom: 1rem; }
            .chart-container { max-width: 100%; }
        }
    </style>
</head>
<body>
    <div class="page-container">
        <div class="left-column">
            <div class="toc-wrapper">
                <div class="toc-container">
                    <h2 class="toc-header" id="tocToggle">Contents</h2>
                    <div class="toc-content" id="tocContent">
                        <ul class="toc-list">
                            <li><a href="#summary">Executive Summary</a></li>
                            <li><a href="#breakthrough">Acquisition Breakthrough</a></li>
                            <li><a href="#engagement">Unprecedented Engagement</a></li>
                            <li><a href="#quality">High-Quality Leads</a></li>
                            <li><a href="#reach">Broad Market Reach</a></li>
                            <li><a href="#momentum">Growth & Timing</a></li>
                            <li><a href="#next">Next Steps</a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>

        <div class="main-column">
            <h1>Market Traction Update</h1>
            <p class="subtitle">Patient Acquisition Breakthrough - Q2 2025</p>

            <!-- Mobile TOC -->
            <div class="mobile-toc">
                 <div class="toc-container">
                    <h2 class="toc-header collapsed" id="mobileTocToggle">Contents</h2>
                    <div class="toc-content collapsed" id="mobileTocContent">
                        <ul class="toc-list">
                           <li><a href="#summary">Executive Summary</a></li>
                            <li><a href="#breakthrough">Acquisition Breakthrough</a></li>
                            <li><a href="#engagement">Unprecedented Engagement</a></li>
                            <li><a href="#quality">High-Quality Leads</a></li>
                            <li><a href="#reach">Broad Market Reach</a></li>
                            <li><a href="#momentum">Growth & Timing</a></li>
                            <li><a href="#next">Next Steps</a></li>
                        </ul>
                    </div>
                </div>
            </div>

            <h2 id="summary">Executive Summary</h2>
            <p>After building our AI medical justice agents within the malpractice firm, I've shifted our focus to direct patient acquisition. The results have exceeded my expectations by far – we've cut costs dramatically while attracting high-quality leads, with engagement patterns that signal strong product-market fit.</p>
            <div class="highlight-box">
                <p><strong>Key Highlights:</strong></p>
                <ul>
                    <li><strong>95% Reduction in Cost-Per-Lead:</strong> From $80 industry standard to just $4.30 through systematic optimization.</li>
                    <li><strong>683 Patient Leads Acquired:</strong> Real people sharing detailed medical narratives and contact information.</li>
                    <li><strong>Strong Organic Engagement:</strong> Our ads are generating hundreds of organic comments and shares even at small scale.</li>
                </ul>
            </div>

            <h2 id="breakthrough">The Acquisition Breakthrough: Efficiency at Scale</h2>
            <p>I started our patient acquisition experiments by benchmarking against the typical $80 - $120 per lead cost that medical malpractice firms like RLG pay.</p>
             <p>The end goal of our growth investments is to become <i>the</i> brand consumers think of when they feel they or a loved one experienced inadequate healthcare, just as BetterHelp is for therapy.</b></p>
             <p>Wondering how BetterHelp did it, I trawled through LinkedIn and tracked down BetterHelp's creative director at their peak growth, James Imrie. I had read about his work in <a href="https://www.adweek.com/creativity/refusing-help-is-like-free-falling-without-a-parachute-in-betterhelps-new-campaign/" target="_blank">Adweek</a> where his campaigns were <a href="https://www.adweek.com/brand-marketing/betterhelps-sincere-ad-looks-at-the-importance-of-mens-mental-health/" target="_blank">profiled</a>. After pitching him over text, getting ignored, and spamming him, we finally had a call. He asked for another and has since began consistently volunteering his advice and assistance. Now I've finally compensated him with some equity and he has taken full reins of our ad campaigns and optimized them an order of magnitude above the standard in medical malpractice.</p>
             <div class="statistics">
                <div class="stat-box">
                    <div class="stat-number">$4.30</div>
                    <div class="stat-label">Current Cost-Per-Lead</div>
                </div>
                <div class="stat-box">
                    <div class="stat-number">>18x</div>
                    <div class="stat-label">Improvement vs. Industry Standard ($80)</div>
                </div>
                 <div class="stat-box">
                    <div class="stat-number">683</div>
                    <div class="stat-label">Total Leads Generated</div>
                </div>
            </div>
             <p>This cost reduction isn't just about efficiency – it fundamentally changes who can access our help. We're now able to reach patients who would have been economically impossible to serve under the traditional model.</p>


            <h2 id="engagement">Unprecedented Engagement Signals Resonance</h2>
            <p>What's surprised me most is the quality of engagement we're seeing. Even at our modest scale (just a few thousand impressions), people are connecting with our message in ways I've rarely seen:</p>
            <ul>
                <li><strong>Hundreds of Likes, Comments & Shares:</strong> Users are actively engaging with what should be "just ads," sharing deeply personal healthcare experiences with strangers in the comments.</li>
                <li><strong>Detailed Submissions:</strong> Instead of quick form fills, we're getting paragraph-long narratives – people are taking real time to tell their stories, often in painful detail.</li>
                <li><strong>Word-of-Mouth Spreading:</strong> About 10% of our leads have no ad tracking, suggesting they're finding us through referrals.</li>
            </ul>
            <p>This level of engagement tells me we've tapped into something people have been waiting for – a trusted way to address medical experiences that left them feeling unheard or uncertain, without the intimidation of traditional legal channels.</p>

            <h2 id="quality">High-Quality, Targeted Lead Generation</h2>
            <p>While most firms buy recycled, generic personal injury leads that get resold repeatedly, we're generating a fundamentally different type of lead pool. We specifically target high-value diagnostic and disease areas where actionable negligence is more common.</p>
             <div class="highlight-box">
                <p>This targeted approach generates a much richer funnel of potentially viable cases, rather than the scattershot approach typical in the industry.</p>
            </div>

            <h3>Understanding Our Case Mix: Error Types</h3>
            <p>The pattern of errors reported shows clear concentration in areas I suspected would dominate:</p>
            <div class="chart-container">
                <img src="../../public/images/maltype_piechart.png" alt="Pie chart showing Medical Error Type Distribution" class="chart-image">
                <p class="chart-caption">Medical Error Type Distribution (n=683)</p>
                 <div class="image-description">
                    Misdiagnosis makes up nearly half our cases (45%), which aligns with what research shows is a major source of preventable harm. Other significant categories include delayed treatment (13%) and surgical errors (10%). This validates my hypothesis about which error types would be most prevalent.
                </div>
            </div>

             <h3>Understanding Our Case Mix: Clinical Specialties</h3>
             <p>I'm encouraged to see broad representation across medical fields:</p>
            <div class="chart-container">
                <img src="../../public/images/disarea_piechart.png" alt="Pie chart showing Medical Specialty Distribution" class="chart-image">
                <p class="chart-caption">Medical Specialty Distribution (n=683)</p>
                <div class="image-description">
                    While some initial submissions don't specify specialty (20%), we're seeing strong representation in orthopedics (17%), neurology (16%), cancer (11%), and GI (10%). This distribution across specialties shows the widespread nature of these issues – they're not confined to just one area of medicine.
                </div>
            </div>


            <h2 id="reach">Broad Market Reach: Geographic and Provider Diversity</h2>
            <p>We've quickly established a nationwide footprint that suggests the problem isn't regional:</p>
            <div class="chart-container">
                <img src="../../public/images/state_piechart.png" alt="Pie chart showing Geographic Distribution of Cases by State" class="chart-image">
                <p class="chart-caption">Geographic Distribution of Cases (46 States Represented)</p>
                 <div class="image-description">
                     Our cases come from 46 different states, with expected concentration in major healthcare markets like California (10%), New York (6%), Texas (6%), and Florida (6%). What's fascinating is how broadly distributed the remaining cases are. We're even seeing inquiries from outside the US – something we're not equipped to handle yet but signals potential international application.
                </div>
            </div>
            <p>The provider types are equally diverse – from small private clinics to major hospital systems. This isn't a problem isolated to one segment of healthcare delivery.</p>

            <h3>Capturing Cases Across the Timeline</h3>
            <p>I'm particularly intrigued by the timeline distribution of when patients report incidents:</p>
             <div class="chart-container">
                <img src="../../public/images/timechart.png" alt="Bar chart showing Time Between Incident and Report" class="chart-image">
                <p class="chart-caption">Time Between Incident and Report</p>
                <div class="image-description">
                    While most reports come in the first few months after an incident (highest volume in 0-3 months), we're capturing cases across the entire timeline. In fact, 70.7% of cases are reported within 3 years, but we see significant reporting even years later. This matters because these longer-term cases often involve the most life-altering consequences and highest damages.
                </div>
            </div>

            <h2 id="next">Strategic Implications & Next Steps</h2>
            <p>These results validate my core hypothesis: there's significant unmet demand for a trusted, accessible patient advocacy service that can be reached efficiently through targeted, data-driven acquisition. The quality of engagement confirms we're positioning ourselves correctly in the market.</p>
            <p>My immediate focus is on:</p>
            <ul>
                <li><strong>Scaling Infrastructure:</strong> Enhancing our AI evaluation pipeline to handle increasing case volume without losing precision.</li>
                <li><strong>Deepening Analysis:</strong> Refining our pattern recognition for specific providers and jurisdictions to improve case selection.</li>
                <li><strong>Expanding Channels:</strong> Testing partnerships with access-a-ride services, influencer collaborations, and targeted offline campaigns.</li>
                <li><strong>Optimizing Conversion:</strong> Streamlining the journey from initial lead to qualified case assessment.</li>
            </ul>
            <p>With this momentum, I believe we're positioned to fundamentally change how medical justice works, opening access to patients who've been shut out of the current system while creating the data foundation for broader healthcare improvement.</p>

        </div>

        <div class="right-column">
            <!-- Empty right column -->
        </div>
    </div>

    <footer>
        <div class="footer-container">
            <p>Afterimage, Inc. • Confidential • Q2 2025 Update</p>
        </div>
    </footer>

    <script>
        // Basic TOC Toggle Functionality
        document.addEventListener('DOMContentLoaded', function() {
            // Desktop TOC
            const tocToggle = document.getElementById('tocToggle');
            const tocContent = document.getElementById('tocContent');
            if (tocToggle && tocContent) {
                tocToggle.addEventListener('click', function() {
                    tocToggle.classList.toggle('collapsed');
                    tocContent.classList.toggle('collapsed');
                });
            }

            // Mobile TOC
            const mobileTocToggle = document.getElementById('mobileTocToggle');
            const mobileTocContent = document.getElementById('mobileTocContent');
            if (mobileTocToggle && mobileTocContent) {
                // Ensure it starts collapsed
                mobileTocToggle.classList.add('collapsed');
                mobileTocContent.classList.add('collapsed');

                mobileTocToggle.addEventListener('click', function() {
                    mobileTocToggle.classList.toggle('collapsed');
                    mobileTocContent.classList.toggle('collapsed');
                });
                 // Close mobile TOC on link click
                const mobileTocLinks = mobileTocContent.querySelectorAll('a');
                mobileTocLinks.forEach(link => {
                    link.addEventListener('click', () => {
                         mobileTocToggle.classList.add('collapsed');
                         mobileTocContent.classList.add('collapsed');
                    });
                });
            }

            // Smooth Scrolling & Active State for TOC links (Desktop & Mobile)
             const observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    const id = entry.target.getAttribute('id');
                    const link = document.querySelector(\`.toc-list a[href="#\${id}"]\`);
                    const mobileLink = document.querySelector(\`#mobileTocContent .toc-list a[href="#\${id}"]\`);

                    if (entry.isIntersecting && entry.intersectionRatio >= 0.5) { // Highlight when 50% visible
                        document.querySelectorAll('.toc-list a.active').forEach(activeLink => activeLink.classList.remove('active'));
                         if(link) link.classList.add('active');
                         if(mobileLink) mobileLink.classList.add('active');
                    }
                });
            }, { rootMargin: "-20% 0px -50% 0px", threshold: 0.5 }); // Adjust rootMargin/threshold as needed

            document.querySelectorAll('.main-column h2[id]').forEach(section => {
                observer.observe(section);
            });

            // Add smooth scroll to all TOC links
            document.querySelectorAll('.toc-list a[href^="#"]').forEach(anchor => {
                anchor.addEventListener('click', function (e) {
                    e.preventDefault();
                    const targetId = this.getAttribute('href');
                    const targetElement = document.querySelector(targetId);
                    if(targetElement) {
                        targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    }
                });
            });
        });
    </script>
</body>
</html> `;

export default memoUpdateContent;
